// extracted by mini-css-extract-plugin
export default {"root":"addOrder_root__CphSR"};